import API from 'api';
import { actionCreator } from 'util/actions';
import { BOARD_FIELDS_MINIMAL } from './fields';

// Ation types
export const LOAD_MEMBER_CARDS_REQUEST = 'loaders/LOAD_MEMBER_CARDS_REQUEST';
export const LOAD_MEMBER_CARDS_SUCCESS = 'loaders/LOAD_MEMBER_CARDS_SUCCESS';
export const LOAD_MEMBER_CARDS_ERROR = 'loaders/LOAD_MEMBER_CARDS_ERROR';

// Ation creators
const loadMemberCardsRequest = actionCreator(LOAD_MEMBER_CARDS_REQUEST);
const loadMemberCardsSuccess = actionCreator(LOAD_MEMBER_CARDS_SUCCESS);
const loadMemberCardsError = actionCreator(LOAD_MEMBER_CARDS_ERROR);

export const loadMemberCards = (idMemberOrUsername) => {
  return async (dispatch) => {
    try {
      dispatch(loadMemberCardsRequest(idMemberOrUsername));

      const member = await API.client.rest.get(
        `members/${idMemberOrUsername}`,
        {
          query: {
            boards: 'open,starred',
            // eslint-disable-next-line @typescript-eslint/camelcase
            board_fields: BOARD_FIELDS_MINIMAL,
            // eslint-disable-next-line @typescript-eslint/camelcase
            board_memberships: 'me',
            cards: 'visible',
          },
        },
      );

      dispatch(loadMemberCardsSuccess(member));
    } catch (err) {
      dispatch(loadMemberCardsError(err));
    }
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/loaders/load-member-cards.js